import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ parent, screen }) => {
  return (
    <nav className="py-3 px-4 w-full flex justify-center">
      <ol className="list-reset flex items-center text-lg md:text-2xl font-semibold text-gray-600">
        {/* Home Link */}
        <li>
          <Link to="/" className="flex items-center">
            <FontAwesomeIcon icon={faHome} className="mr-2 text-emerald-600" />
            Home
          </Link>
        </li>

        {/* Separator */}
        <li>
          <span className="mx-2">&gt;</span>
        </li>

        {/* Parent Link (if provided) */}
        {parent && (
          <>
            <li>{parent}</li>
            <li>
              <span className="mx-2">&gt;</span>
            </li>
          </>
        )}

        {/* Screen */}
        <li>{screen}</li>
      </ol>
    </nav>
  );
};

// Prop validation
Breadcrumb.propTypes = {
  parent: PropTypes.string, // Optional prop for parent
  screen: PropTypes.string.isRequired, // Required prop for screen
};

export default Breadcrumb;
